import { Flex, Spacer, IconButton, Heading } from '@chakra-ui/react';
import { IoChevronForward, IoChevronBack } from 'react-icons/io5';

import { addMonths, format } from 'date-fns';

type ControlBarProps = {
  date: Date;
  onChangeDate: (date: Date) => void;
};

export default function ControlBar({ date, onChangeDate }: ControlBarProps) {
  const handlePrevMonth = () => {
    onChangeDate(addMonths(date, -1));
  };
  const handleNextMonth = () => {
    onChangeDate(addMonths(date, 1));
  };
  return (
    <Flex align="center">
      <IconButton
        aria-label="prev-month"
        variant="ghost"
        icon={<IoChevronBack />}
        onClick={handlePrevMonth}
      />
      <Spacer />
      <Heading fontSize="2xl">{format(date, 'yyyy MMMM')}</Heading>
      <Spacer />
      <IconButton
        aria-label="next-month"
        variant="ghost"
        icon={<IoChevronForward />}
        onClick={handleNextMonth}
      />
    </Flex>
  );
}
